<template>
    <div class="col-sm-4">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col mt-0">
                        <h5 class="card-title">User Value</h5>
                    </div>
                    <div class="col-auto">
                        <div class="avatar">
                            <div class="avatar-title rounded-circle bg-purple">
                                <i class="align-middle fas fa-fw fa-sign"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <h1 class="display-5 mt-1 mb-3">{{ userValue }}</h1>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'UserValue',
    props: ['userValue']
}
</script>
